import React, { useState, useCallback, useTransition } from 'react';
import ClientManagement from './ClientManagement';
import ExportCSV from '../../reusable/Client/ExportCSV';
import MonthFilter from '../../reusable/Client/MonthFilter';
import { useTranslation } from 'react-i18next';

const Client: React.FC = () => {
  const { t } = useTranslation('client');
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const initialDateRange = {
    start: new Date(currentYear, currentMonth, 1).toISOString().split('T')[0],
    end: new Date(currentYear, currentMonth + 1, 0).toISOString().split('T')[0],
  };

  const [dateRange, setDateRange] = useState(initialDateRange);
  const [showClientHour, setShowClientHour] = useState(true);

  const handleDateRangeChange = useCallback(
    (range: { start: string; end: string }) => {
      setDateRange(range);
    },
    []
  );

  const handleClientHourChange = (value: boolean) => {
    setShowClientHour(value);
  };

  return (
    <section className="px-4 py-3 space-y-3">
      <div className="flex justify-between">
        <h6 className="font-bold text-title">{t('title')}</h6>
        <div className="flex flex-row space-x-2 items-center">
          <MonthFilter onDateRangeChange={handleDateRangeChange} />
          {/* Pass dateRange and showClientHour to ExportCSV */}
          <ExportCSV dateRange={dateRange} showClientHour={showClientHour} />
        </div>
      </div>
      <div className="bg-white rounded-md p-4">
        <ClientManagement
          dateRange={dateRange}
          onClientHourChange={handleClientHourChange}
        />
      </div>
    </section>
  );
};

export default Client;
